import {observer, React} from '@api'
import {IconButton, useWhiteboardStore} from '@modules/whiteboard'
import {DotFilledIcon} from '@radix-ui/react-icons'
import * as css from './FocusButton.css'

export const FocusButton = observer(function FocusButton() {
  const {onToggleFocus} = useWhiteboardStore()

  return (
    <div className={css.root}>
      <IconButton onClick={onToggleFocus}>
        <DotFilledIcon/>
      </IconButton>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/FocusButton/FocusButton.tsx